import React from "react";

import { makeStyles } from "tss-react/mui";

type Props = {
  status: string;
};

const useStyles = makeStyles()({
  dot: {
    width: 8,
    height: 8,
    borderRadius: 50,
    backgroundColor: "#B8BEC9",
    marginRight: 8,
  },
  dotCurrent: {
    backgroundColor: "#FFD98A",
  },
  dotCancelled: {
    backgroundColor: "#FF6262",
  },
  dotUpcoming: {
    backgroundColor: "#2D87BB",
  },
  dotAll: {
    backgroundColor: "transparent",
  },
});

const StatusDotIndicator: React.FC<Props> = ({ status }) => {
  const { classes, cx } = useStyles();
  return (
    <div
      className={cx(classes.dot, {
        [classes.dotCurrent]: status == "CURRENT",
        [classes.dotCancelled]: status == "CANCELLED",
        [classes.dotUpcoming]: status == "UPCOMING",
        [classes.dotAll]: status == "ALL",
      })}
    ></div>
  );
};

export default StatusDotIndicator;
